import { Message } from "../../types/types";
import { updateLinksToOpenInNewTabs } from "../../utils/product/updateLinksToOpenInNewTab";
import { MessageWithCategoryAndType } from "../../utils/product/getPromoMessaging";

const lineBreakTags = ["<br>", "<br/>"];

export const cleanPromoDescription = (promotion: Message) => {
  let cleanedDescription = cleanDescription(promotion);
  cleanedDescription = removePrecedingLineBreaks(cleanedDescription);
  return cleanedDescription;
};

export const cleanDescription = (promotion: Message) => {
  if (!promotion.description) return null;

  const title = promotion.title.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const duplicateTitle = `(?:<strong>\\s*)?${title}(?:\\s*</strong>)?`;
  const titleParagraphWithFollowingParagraph = new RegExp(
    `<p>\\s*(${duplicateTitle})\\s*</p>\\s*<p>([\\s\\S]*?)</p>`,
    "i",
  );
  const titleBeforeParagraph = new RegExp(
    `^\\s*(${duplicateTitle})\\s*<p>([\\s\\S]*?)</p>`,
    "i",
  );

  let cleanedDescription = promotion.description.trim();
  cleanedDescription = cleanedDescription.replace(
    titleParagraphWithFollowingParagraph,
    "<p>$1$2</p>",
  );
  cleanedDescription = cleanedDescription.replace(
    titleBeforeParagraph,
    "<p>$1$2</p>",
  );
  return cleanedDescription.trim();
};

export const removeTitleFromDescription = (promotion: Message) => {
  const cleanTitle = promotion.title.trim();

  if (!promotion.description) return null;

  let cleanedDescription = promotion.description?.replace(
    // nosemgrep
    `<p><strong>${cleanTitle}</strong></p>`,
    "",
  );

  cleanedDescription = cleanedDescription.replace(
    // nosemgrep
    `<strong>${cleanTitle}</strong>`,
    "",
  );

  // nosemgrep
  cleanedDescription = cleanedDescription.replace(`<p>${cleanTitle}</p>`, "");
  cleanedDescription = cleanedDescription.replace(`${cleanTitle}`, "");
  return cleanedDescription.trim();
};

export const removePrecedingLineBreaks = (
  description: string | null | undefined,
) => {
  if (!description) return null;

  lineBreakTags.map((lineBreakTag) => {
    while (description?.startsWith(lineBreakTag)) {
      description = description?.replace(lineBreakTag, "").trim();
    }
  });
  return description;
};

type cleanedPromoMessage = {
  description: string | undefined;
  terms: string | undefined;
};
export const getCleanedPromoDescription = (
  isVersionFour: boolean,
  promotion: MessageWithCategoryAndType,
): cleanedPromoMessage => {
  const descriptionWithTitleFormatting = isVersionFour
    ? promotion.description
    : removeTitleFromDescription(promotion);
  const descriptionWithoutLineBreaks = removePrecedingLineBreaks(
    descriptionWithTitleFormatting,
  );
  const updatedLinksDescription = updateLinksToOpenInNewTabs(
    descriptionWithoutLineBreaks,
  );

  const [description, terms] = updatedLinksDescription.split(
    "<strong>Terms and conditions</strong>",
  );
  return {
    description,
    terms,
  };
};
